import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {FormattedMessage, injectIntl} from 'react-intl';
import Close from 'react-icons/lib/io/close';
import './styles.scss';
import BaseButton from "../button/BaseButton";

@injectIntl
@inject('dialogStore')
@observer
class CameraErrorComponent extends Component {
    renderBullets = () => {
        const numListItems = 4;

        let result = [];
        for (let i = 1; i < numListItems + 1; i++) {
            result.push(<li key={`Bullet${i}`}><FormattedMessage id={`camera.error.dialog.list.item${i}`}
                                                                 values={{test: <a href={'mailto:info@musico.io'}>info@musico.io</a>}}/></li>);
        }
        return result;
    };

    render() {
        const {onClose, onClick, intl: {formatMessage: translate}} = this.props;

        return (
            <div className="camera-error-modal">
                <h5><FormattedMessage id={'camera.error.dialog.title.header'}/></h5>
                <button className="camera-error-modal-close" onClick={onClose}>
                    <Close/>
                </button>
                <h3><FormattedMessage id={'camera.error.dialog.title'}/></h3>
                <h4><FormattedMessage id={'camera.error.dialog.list.header'}/></h4>
                <ol className="camera-error-info-list list-unstyled">
                    {this.renderBullets()}
                </ol>
                <div className="camera-error-modal-buttons">
                    <BaseButton
                        label={translate({id: 'camera.error.dialog.button.text'})}
                        onClick={onClick}
                    />
                </div>
            </div>
        );
    }
}

export default CameraErrorComponent;
